import { h } from "vue";
import type { IconSet, IconProps, IconAliases } from "vuetify";
import {Icon} from "#components";

const aliases: IconAliases = {
  complete: "solar:alt-arrow-down-linear",
  cancel: "material-symbols-light:close-small-outline",
  close: "material-symbols-light:close-small-outline",
  delete: "material-symbols-light:close-small-outline",
  clear: "material-symbols-light:close-small-outline",
  success: "solar:alt-arrow-down-linear",
  info: "solar:alt-arrow-down-linear",
  warning: "solar:alt-arrow-down-linear",
  error: "solar:alt-arrow-down-linear",
  prev: "solar:alt-arrow-left-linear",
  next: "solar:alt-arrow-right-linear",
  checkboxOn: "ic:baseline-check-box",
  checkboxOff: "ic:baseline-check-box-outline-blank",
  checkboxIndeterminate: "ic:baseline-indeterminate-check-box",
  delimiter: "solar:alt-arrow-down-linear",
  sortAsc: "solar:arrow-down-linear",
  sortDesc: "solar:arrow-up-linear",
  expand: "solar:alt-arrow-down-linear",
  menu: "solar:alt-arrow-down-linear",
  subgroup: "solar:alt-arrow-down-linear",
  dropdown: "solar:alt-arrow-down-linear",
  radioOn: "ic:round-radio-button-checked",
  radioOff: "ic:sharp-radio-button-unchecked",
  edit: "solar:alt-arrow-down-linear",
  ratingEmpty: "tabler:star",
  ratingFull: "tabler:star-filled",
  ratingHalf: "tabler:star-half-filled",
  loading: "solar:alt-arrow-down-linear",
  first: "solar:double-alt-arrow-left-linear",
  last: "solar:double-alt-arrow-right-linear",
  unfold: "solar:alt-arrow-down-linear",
  file: "solar:alt-arrow-down-linear",
  plus: "solar:alt-arrow-down-linear",
  minus: "solar:alt-arrow-down-linear",
  calendar: "solar:alt-arrow-down-linear",
  collapse: "solar:alt-arrow-up-linear",
};

const custom: IconSet = {
  component: (props: IconProps) =>
    h(Icon, {
      name: props.icon,
      tag: props.tag,
      disabled: props.disabled,
    }),
};

export { aliases, custom };
